<template>
  <div id="login-page">
    <div id=login-header>
      <h1>Reset Password</h1>
      <p>Please enter your new account password below...</p>
    </div>
    <v-app id="inspire">
      <div id=password-form>
        <v-form ref="login" v-model="valid" lazy-validation>
          <v-text-field type="password" v-model="password" :rules="passwordRules" label="New Password" required> </v-text-field>
          <v-text-field type="password" v-model="passwordRepeat" :rules="passwordRules" label="Repeat New Password" required> </v-text-field>
          <v-btn :disabled="!valid" color="success" @click="changePassword(password, passwordRepeat)">Change Password</v-btn>
        </v-form>
      </div>
    </v-app>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { set } from 'vue/types/umd';
export default {
  data: () => ({
    password: '',
    passwordRepeat: '',
    token: '',
    tokenID: '',
    valid: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    },
    passwordRules: [
        v => !!v || 'Password is required',
      ],
  }),
  name: 'App',

  components: {
  },

  async created(){
    if (!this.$route.query.tokenID){
      this.$router.push('login');
      return
    }
    const tokenID = this.$route.query.tokenID

    if (!this.$route.query.token){
      this.$router.push('login');
      return
    }
    const token = this.$route.query.token

    this.token = token;
    this.tokenID = tokenID

    const apiAuthData = {
      'token': this.token,
      'tokenID': this.tokenID
    }

    const response = await fetch(localStorage.apiURL + "/app/reset-password/checkauth", {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(apiAuthData)
    });

    if (!response.ok){
      this.$router.push('login');
      return
    }

    let data = await response.json();

    if (!data.success){
      this.error(data.msg);
      return
    }

    console.log("success");

  },
  methods: {
    error(message, color="error"){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = color;
    },
    async changePassword(password, passwordRepeat){

      console.log(password);
      console.log(passwordRepeat);

      if (this.passwordRepeat != this.password){
        this.error("Passwords do not match");
        return;
      }

      if (this.password.length < 6){
        this.error("Password must be a minimum of 6 characters");
        return;
      }
    const response = await fetch(localStorage.apiURL + "/app/reset-password", {
      method: "PUT",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
      'token': this.token,
      'tokenID': this.tokenID,
      'password': this.password
      })
    });

      if (!response.ok){
        this.error("An Error Occured, Try Again");
        return
      }

      let data = await response.json();

      if (!data.success){
        this.error(data.msg);
        return
      }
      alert("Success! Password Changed! Please login with your new password")
      this.$router.push('login')

    },
  },
};
</script>

<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}

p{
  margin: 0;
}

#login-header {
  margin-top: 100px;
  text-align: center;
}

@media screen and (max-width: 1200px) {
  #password-form {
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    align-content: center;
  }
}
@media screen and (min-width: 1200px) {
  #password-form {
    margin-top: 25px;
    margin-left: 25%;
    align-content: center;
    width: 50%
  }
}

</style>
